import LockIcon from "@mui/icons-material/LockOutlined";
import type { ChipProps } from "@mui/material";
import { FormattedMessage } from "react-intl";

import { StatusChip } from "./status-chip";

export function ReadOnlyChip(props: Omit<ChipProps, "variant">) {
  return (
    <StatusChip
      icon={<LockIcon />}
      label={<FormattedMessage id="Read-only" />}
      data-testid="read-only-chip"
      {...props}
      variant="dark"
    />
  );
}
